var render = function render(){var _vm=this,_c=_vm._self._c;return _c('youtube',{ref:"youtube",attrs:{"video-id":_vm.videoId,"player-vars":_vm.playerVars},on:{"ready":_vm.videoReady,"ended":_vm.videoEnded,"playing":_vm.videoPlaying,"paused":_vm.videoPaused}})
}
var staticRenderFns = []

export { render, staticRenderFns }